<script setup>

import {ref} from "vue"

const selectedIndex = ref(-1)

const handleToggle = (index) => {
  selectedIndex.value = selectedIndex.value === index ? -1 : index
}
</script>

<template>
  <div class="section section--accordions">
    <h5 class="heading heading--archivo heading--600">
      {{ $t('Frequently asked Questions') }}
    </h5>
    <div v-for="(faq, faqIndex) in Object.values($tm('faqs'))" :key="`q${faqIndex}`" class="accordion">
      <div @click="handleToggle(faqIndex)" class="accordion__title-wrapper">
        <h5 class="accordion__title">{{ $rt(faq.question) }}</h5>
        <div class="accordion__toggle-wrapper">
          <div :class="{ active: selectedIndex === faqIndex }" class="accordion__toggle"></div>
        </div>
      </div>
      <div :class="{ open: selectedIndex === faqIndex }" class="accordion__content">
        <template v-for="(answer, answerIndex) in Object.values(faq.answers)" :key="`q${faqIndex}a${answerIndex}`">
          <div v-html="$rt(answer)"></div>
        </template>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.heading {
  padding-bottom: 24px !important;
  font-variation-settings: "wdth" 88 !important;
}

.accordion__title {
  font-size: 16px !important;
  padding: 16px 0 !important;
  max-width: 90%;
}

.accordion__content > div, a {
  font-size: 14px !important;
}
</style>